module.exports = __webpack_public_path__ + "assets/images/family_y.ac7f50cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/family_y.png
// module id = 710
// module chunks = 1